module.exports = __webpack_public_path__ + "assets/removeMoneycardErrorImage-f8328c.svg";